<template>
  <div class="maturity-card">
    <div class="mat-top">
      <TokenLogo :src="token.image" :name="token.name" :size="40" />
      <div class="mat-head">
        <p class="mat-name">{{ token.name }}</p>
        <p class="mat-in">{{ maturesIn }}</p>
      </div>
      <p class="mat-date">{{ dateLabel }}</p>
    </div>
    <div class="mat-divider"></div>
    <div class="mat-foot">
      <span class="mat-foot-label">Principal Returning</span>
      <span class="mat-foot-value">{{ principalLabel }}</span>
    </div>
  </div>
</template>

<script>
import TokenLogo from "@/components/invest/TokenLogo.vue";
import * as inv from "@/utils/invest.js";

export default {
  name: "InvestMaturityCard",
  components: { TokenLogo },
  props: {
    token: { type: Object, required: true },
    currency: { type: String, default: "NGN" },
  },
  computed: {
    maturesIn() {
      const days = inv.daysToMaturity(this.token);
      if (days == null) return "";
      if (days === 0) return "Matures today";
      return `Matures in ${days} ${days === 1 ? "day" : "days"}`;
    },
    dateLabel() {
      return inv.formatDayMonthYear(this.token.maturity);
    },
    principalLabel() {
      return inv.money(inv.principalReturning(this.token), this.currency, 2);
    },
  },
};
</script>

<style lang="scss" scoped>
.maturity-card {
  background: #ffffff;
  border: 1px solid #e8ecf4;
  border-radius: 8px;
  padding: 14px 16px;
}

.mat-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mat-head {
  flex: 1;
  min-width: 0;
}

.mat-name {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #001240;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mat-in {
  margin: 2px 0 0;
  font-size: 11px;
  font-weight: 500;
  color: #f2994a;
}

.mat-date {
  flex-shrink: 0;
  margin: 0;
  font-size: 11px;
  color: #8791a7;
}

.mat-divider {
  height: 1px;
  background: #e8ecf4;
  margin: 12px 0;
}

.mat-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mat-foot-label {
  font-size: 12px;
  color: #4f5877;
}

.mat-foot-value {
  font-size: 13px;
  font-weight: 500;
  color: #001240;
}
</style>
